import HeroBackgroundPage from '@/components/templates/HeroBackgroundPage';
import {
  CREATOR_APPLICATION_BACKGROUND,
  CREATOR_APPLICATION_BACKGROUND_OPACITY,
} from '@/constants/creatorApplication';
import CreatorApplicationContentPolicy from '@/modules/contentCreator/CreatorApplicationContentPolicy';
import { getContentPolicyQuery } from '@/queries/legal';
import { useCreatorApplicationStore } from '@/store/useCreatorApplicationStore';
import { useAppStore } from '@/store/useAppStore';
import { getUnacceptedContentPolicy, hasUnacceptedNonContentPolicyDocument } from '@/utils/onboardingUtils';
import { createFileRoute, redirect } from '@tanstack/react-router';

const CreatorApplicationContentPolicyPage = () => (
  <HeroBackgroundPage
    heroChildren={<CreatorApplicationContentPolicy />}
    backgroundOverlay={CREATOR_APPLICATION_BACKGROUND}
    backgroundOverlayOpacity={CREATOR_APPLICATION_BACKGROUND_OPACITY}
    isBackgroundFixed
  />
);

export const Route = createFileRoute('/creator/apply/content-policy/')({
  staticData: { title: 'Content Policy' },
  component: CreatorApplicationContentPolicyPage,
  loader: async ({ context }) => context.queryClient.ensureQueryData(getContentPolicyQuery()),
  beforeLoad: ({ context }) => {
    if (!useCreatorApplicationStore.getState().previewData) {
      const isContentCreator = context.auth?.isContentCreator;
      const { legalAcceptanceStatuses } = useAppStore.getState();

      if (isContentCreator && getUnacceptedContentPolicy(legalAcceptanceStatuses)) {
        return;
      }

      if (isContentCreator && hasUnacceptedNonContentPolicyDocument(legalAcceptanceStatuses)) {
        throw redirect({ to: '/eula/update' });
      }

      if (isContentCreator) {
        throw redirect({ to: '/creator/profile' });
      }

      throw redirect({ to: '/creator/apply/form' });
    }
  },
});
